// Registry of DSA pattern explanations. Each pattern gets its own content file
// in this folder. Patterns not yet listed here simply have no "Explanation"
// entry rendered in the tracker — add a file + a line here to enable one.

import arrays from './arrays';
import hashing from './hashing';
import twoPointers from './twoPointers';
import slidingWindow from './slidingWindow';
import stack from './stack';
import binarySearch from './binarySearch';
import linkedList from './linkedList';
import trees from './trees';
import tries from './tries';
import heap from './heap';
import backtracking from './backtracking';
import graphs from './graphs';
import advancedGraphs from './advancedGraphs';
import dp1d from './dp1d';
import dp2d from './dp2d';
import greedy from './greedy';
import intervals from './intervals';
import mathBit from './mathBit';
import matrix from './matrix';
import palindromes from './palindromes';

const EXPLANATIONS = {
  'Arrays': arrays,
  'Hashing': hashing,
  'Two Pointers': twoPointers,
  'Sliding Window': slidingWindow,
  'Stack': stack,
  'Binary Search': binarySearch,
  'Linked List': linkedList,
  'Trees': trees,
  'Tries': tries,
  'Heap / Priority Queue': heap,
  'Backtracking': backtracking,
  'Graphs': graphs,
  'Advanced Graphs': advancedGraphs,
  '1-D Dynamic Programming': dp1d,
  '2-D Dynamic Programming': dp2d,
  'Greedy': greedy,
  'Intervals': intervals,
  'Math & Bit Manipulation': mathBit,
  'Matrix': matrix,
  'Palindromes': palindromes,
};

export default EXPLANATIONS;
